exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a {\n    color: inherit; /* blue colors for links too */\n    text-decoration: inherit; /* no underline */\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/mobileSideMenu/mobileSideMenu.component.css
// module id = ../../../../../src/app/components/mobileSideMenu/mobileSideMenu.component.css
// module chunks = main